import { render, staticRenderFns } from "./CreateWebhookModal.vue?vue&type=template&id=f08bf0a2"
import script from "./CreateWebhookModal.vue?vue&type=script&lang=ts"
export * from "./CreateWebhookModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZInput: require('/build/apps/legacy/components/zeal/ZInput/ZInput.vue').default,ToggleInput: require('/build/apps/legacy/components/Form/ToggleInput.vue').default,ZButton: require('/build/apps/legacy/components/zeal/ZButton/ZButton.vue').default,CopyButton: require('/build/apps/legacy/components/CopyButton.vue').default,ZCheckbox: require('/build/apps/legacy/components/zeal/ZCheckbox/ZCheckbox.vue').default,ZModal: require('/build/apps/legacy/components/zeal/ZModal/ZModal.vue').default})
